import { FC, useEffect, useState } from 'react';
import { useAnimation } from 'framer-motion';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { menuStore } from '@modules/header/adapter/outbound/stores/menu.store';
import { IMenuList } from '@modules/header/domain/models/menu.model';
import { ITab } from '@shared/models/tab.model';
import { CategoryMenuType } from '@shared/types/categoryMenu.type';
import SubMenuMobile from '../subMenu/SubMenuMobile';
import CategoryMenuMobile from './CategoryMenuMobile';
const CategoryMenuMobileLogic: FC = () => {
  const animationControls = useAnimation();
  const [activeTab, setActiveTab] = useState<CategoryMenuType>('foodType');
  const [tabs, setTabs] = useState<ITab[]>([]);
  const [activeMenuList, setActiveMenuList] = useState<IMenuList[]>([]);
  const {
    categoryMenu
  } = menuStore(state => state);
  const {
    setIsMenuMobileOpen,
    isCategoryMenuMobileOpen,
    setIsCategoryMenuMobileOpen
  } = headerStore(state => state);
  useEffect(() => {
    mapGinARaiDeeTab();
  }, [categoryMenu]);
  useEffect(() => {
    setActiveMenuList(categoryMenu[activeTab].menuList);
  }, [isCategoryMenuMobileOpen, activeTab]);
  useEffect(() => {
    if (isCategoryMenuMobileOpen) {
      animationControls.start('open');
    } else {
      animationControls.start('closed');
      setActiveTab('foodType');
    }
  }, [isCategoryMenuMobileOpen, activeMenuList]);
  const onCloseMenu = () => {
    setIsMenuMobileOpen(false);
    setIsCategoryMenuMobileOpen(false);
    animationControls.start('closed');
  };
  const mapGinARaiDeeTab = () => {
    const output = Object.values(categoryMenu).map(({
      id,
      title
    }) => {
      return {
        key: id,
        label: title
      };
    });
    setTabs(output);
  };
  return <SubMenuMobile title="กินอะไรดี?" content={<CategoryMenuMobile tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} menuList={activeMenuList} onCloseMenu={onCloseMenu} animationControls={animationControls} />} isSubMenuMobileOpen={isCategoryMenuMobileOpen} setIsSubMenuMobileOpen={setIsCategoryMenuMobileOpen} onCloseMenu={onCloseMenu} />;
};
export default CategoryMenuMobileLogic;